import type { ComponentProps } from "react";
import { Command as CommandPrimitive } from "cmdk";
import { SearchIcon } from "lucide-react";

import { cn } from "../../../lib/utils";

export type SelectSearchProps = ComponentProps<typeof CommandPrimitive.Input>;

export const SelectSearch = ({ className, ...props }: SelectSearchProps) => (
  <div data-slot="select-search" className="flex h-9 shrink-0 items-center gap-2 border-b px-3">
    <SearchIcon className="size-4 shrink-0 opacity-50" />
    <CommandPrimitive.Input
      className={cn(
        "flex h-9 w-full bg-transparent py-3 text-sm outline-none placeholder:text-muted-foreground disabled:cursor-not-allowed disabled:opacity-50",
        className
      )}
      {...props}
    />
  </div>
);
